import { createContext } from 'react'

export type CampaignPermissions = {
	canConfigureTargeting: boolean
	canApprove: boolean
	canSeeAnalytics: boolean
	canSeeInvoice: boolean
	canSeeExport: boolean
}

export type CampaignCommonContextType = {
	permissions: CampaignPermissions
}

export const CampaignCommonContext = createContext<CampaignCommonContextType>({
	permissions: {
		canConfigureTargeting: false,
		canApprove: false,
		canSeeAnalytics: false,
		canSeeInvoice: false,
		canSeeExport: false,
	},
})
